import AssetApproval from "./AssetApproval"
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import navOperations from "redux/Navigation/operations";
import pendingOrderOperations from 'redux/PendingOrder/operations';
import RejectedBee from "../../../../assets/images/PenndingApproval/Rejected Bee.png";
import WarningBee from "../../../../assets/images/PenndingApproval/Warning Bee.png";
import CommentBee from "../../../../assets/images/PenndingApproval/Comment Bee.png";
import ConfirmationBee from "../../../../assets/images/PenndingApproval/Confirmation Bee.png";
import SuccessBee from "../../../../assets/images/SuccessBee.svg";
import navSelector from "redux/Navigation/selectors";
import pendingOrderSelectors from "redux/PendingOrder/selectors";
import { setIsOrderApprovalComplete } from "redux/PendingOrder/action";
import { CONSTANTS } from "client/utils/constants";
import TransferApprovalDispatch from "Store/Transfer/TransferApproval/TransferApprovalDispatch";
import { setIsTransferItemAndOrderLevelApproval, setTransferOrderApprovalRequest } from "Store/Transfer/TransferApproval/TransferApprovalAction";
import { useNavigate, useParams } from "react-router-dom";
import TransferOrderDispatch from 'Store/Transfer/Transfer/TransferOrderByIdDispatch'
import permissions, { isAuthorized } from "client/utils/Permissions";
import { setIsOverrideActionApplicable } from "Store/Component/OrderApproval/OrderApprovalAction";
import { AlertNotificationDispatch } from "Store/AlertNotification/AlertNotificationDispatch";
import { approvalPopupDisplay, defaultBreadcrumList, popupInitialData } from "utils";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import TransferAction from "Store/Component/Transfer/TransferAction";


const AssetApprovalContainer = () => {
  const [comment, setComment] = useState("");
  const [mobile, setMobile] = useState(false);
  const [commentError, setCommentError] = useState(false);
  const [headerNavItem, setHeaderNavItem] = useState("home");
  const [totalPenaltyFee, setTotalPenaltyFee] = useState(0)
  const [approvalAction, setApprovalAction] = useState<any>({
    actionby: "",
    returnOrderconfirmation: "",
    rejectOrderconfirmation: "",
    approveOrderconfirmation: "",
    submitOrderconfirmation: "",
    cancelorder: ""
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dispatchTransferItemAndOrderLevelApproval = TransferApprovalDispatch.dispatchTransferItemAndOrderLevelApproval(dispatch)
  const getTransferOrderDetailById = TransferOrderDispatch.dispatchGetTransferOrderById(dispatch);
  const dispatchSetIsAlertNotificationApiCalled = AlertNotificationDispatch.dispatchSetIsAlertNotificationApiCalled(dispatch);
  const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
  const dispatchActionPopupValue = pendingOrderOperations.dispatchActionPopup(dispatch);

  const dispatchNav = navOperations.dispatchNav(dispatch);

  const {
    transferOrderByIdData,
    transferOrderApprovalRequest,
    isTransferItemAndOrderLevelApprovalData,
    transferApproverActionData,
    transferApprovalRequestOption,
    headerNav,
    getUserDetails,
    isOverrideActionapplicable,
    activeNavigation,
    afeOrderByIdData,
    isOrderCanceled,
    actionPopupValue
  }: any = useSelector((state: any) => ({
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    transferOrderApprovalRequest: state.TransferApprovalReducer.transferOrderApprovalRequest,
    isTransferItemAndOrderLevelApprovalData: state.TransferApprovalReducer.isTransferItemAndOrderLevelApprovalData,
    transferApproverActionData: state.TransferApprovalReducer.transferApproverActionData,
    transferApprovalRequestOption: state.TransferApprovalReducer.transferApprovalRequestOption,
    headerNav: navSelector.GetHeaderNav(state),
    getUserDetails: state.UserProfile.getUserDetails,
    isOverrideActionapplicable:state.OrderApprovalReducer.isOverrideActionapplicable,
    activeNavigation: state.nav.nav,
    afeOrderByIdData: state.TransferReducer.afeOrderByIdData,
    isOrderCanceled: state.PendingOrder.isOrderCanceled,
    actionPopupValue: state.PendingOrder.actionPopupValue,
  }));

  let { id, requesttype, pagename } = useParams();
  useEffect(() => {
    if (id != undefined && getUserDetails?.permissions?.length > 0) {
      if(isAuthorized(permissions.ApprovalsView)){
        if(requesttype == CONSTANTS.AFEREQUEST){
          dispatch(TransferAction.getAfeOrderById(id))
        }else{
          getTransferOrderDetailById(id);
        }
      }else{
        navigate('/ordermanagement/blank');
      } 
    }
  }, [id, getUserDetails?.permissions])

  const getNextApprover = () => {
    let orderByIdTemp: any = {}
    if(requesttype == CONSTANTS.AFEREQUEST){
      orderByIdTemp = afeOrderByIdData
    }else{
      orderByIdTemp = transferOrderByIdData
    }
    for (let i=0; i <= orderByIdTemp?.approvalHistory[0]?.approvalList?.length; i++){
      if(orderByIdTemp?.approvalHistory[0]?.approvalList[i]?.status == CONSTANTS.ORDER_STATUS.PENDING_APPROVAL){
        return orderByIdTemp?.approvalHistory[0]?.approvalList[i]?.assignedUserEmail
      }
    }
    if (
      !orderByIdTemp?.approvalHistory[0]?.approvalList?.some(
        (item: any) => item?.status === CONSTANTS.ORDER_STATUS.PENDING_APPROVAL
      )
    ) {
      for (let i = 0; i < (orderByIdTemp?.approvalHistory[0]?.additionalApprovalList?.length ?? 0); i++) {
        if (orderByIdTemp?.approvalHistory[0]?.additionalApprovalList[i]?.status === CONSTANTS.ORDER_STATUS.PENDING_APPROVAL) {
          return orderByIdTemp?.approvalHistory[0]?.additionalApprovalList[i]?.assignedUserEmail;
        }
      }
    }
    return undefined;
  }

  useEffect(()=>{
    let orderByIdTemp: any = {}
    if(requesttype == CONSTANTS.AFEREQUEST){
      orderByIdTemp = afeOrderByIdData
    }else{
      orderByIdTemp = transferOrderByIdData
    }
    if(orderByIdTemp?.hasOwnProperty('approvalHistory')){
    if((getUserDetails?.emailId?.toLowerCase() == getNextApprover()?.toLowerCase()) && getNextApprover()?.toLowerCase() != undefined && getNextApprover()?.toLowerCase() != null){
      dispatch(setIsOverrideActionApplicable(false))
    }else if((getUserDetails?.emailId?.toLowerCase() != getNextApprover()?.toLowerCase()) && getNextApprover()?.toLowerCase() != undefined && getNextApprover()?.toLowerCase() != null && (isAuthorized(permissions.SuperApproval_Approvals) || isAuthorized(permissions.ViewAllPendingApprovals))){
      dispatch(setIsOverrideActionApplicable(true))
    } else{
      if(requesttype == CONSTANTS.AFEREQUEST){
        navigate('/ordermanagement/afeorderdetail/'+ id + '/home/' + requesttype)
      }else{
        navigate('/ordermanagement/assetorderdetail/' + id + '/home')
      }
    }
    let totalPenaltyFeeTemp = 0
    
    orderByIdTemp?.transferDisposeReactivationDetails?.map((details?: any) => {
        if(details?.orderRequestType === CONSTANTS?.DISPOSITION_REQUEST){
          details?.assets?.map((assetItem?: any) => {
            totalPenaltyFeeTemp =  totalPenaltyFeeTemp + assetItem?.dispositionPenaltyFee
          })

        }
    });
    setTotalPenaltyFee(totalPenaltyFeeTemp)
    
  }
  },[transferOrderByIdData, afeOrderByIdData])

  useEffect(() => {
    const resizeFun = () => {
      if (window.innerWidth < 600) {
        setMobile(true)
      }
      else {
        setMobile(false);
      }
    }
    resizeFun();
    window.addEventListener('resize', resizeFun)
    return () => window.removeEventListener('resize', resizeFun)
  }, []);

  useEffect(() => {
    setHeaderNavItem(headerNav);
  }, [headerNav]);

  const wrapperRef = useRef<any>(null);
  useEffect(() => {
      document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
  }, [activeNavigation]);

  const [WarningPopupcontent, setWarningPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });

  const warningHideDialog = () => {
    setWarningPopupcontent({ ...WarningPopupcontent, isDialogVisible: false })
  }

  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);

  const onChangeComment = (_e: any, text: string) => {
    if (text.length > 500) {
      setCommentError(true);
    } else {
      setCommentError(false);
    }
    setComment(text);
  };

  const popupOutlinebtnOnclick = (item: any) => {
    if (item !== "") {
      dispatchNav(item);
      dispatchSetIsAlertNotificationApiCalled(true)
      dispatch(setIsTransferItemAndOrderLevelApproval(null))
      dispatch(TransferAction.setAfeOrderByIdData({}));
      dispatch(TransferAction.setSelectedRequestType(""));
      navigate('/ordermanagement');
    }
    if (actionPopupValue.actionby === "CancelOrderBtn") {
      dispatchActionPopupValue({})
      isOrderCanceled.approval = undefined;
      if(pagename === CONSTANTS.PAGE_NAME.ASSET){
            dispatchNav('Asset')
          }else{
            dispatchNav('Home')
          }
          navigate('/ordermanagement');
    }
    hideDialog();
  };

  const erroOrderConfirmation = (
    <>
      <p>
        <b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> : {transferOrderByIdData?.orderId}
      </p>
      <p>Something went wrong..! Please try again later</p>
    </>
  );

  useEffect(() => {
    let beeImage = {
      SuccessBee: SuccessBee,
      RejectedBee: RejectedBee
    }
    approvalPopupDisplay(setPopupcontent, Popupcontent, isTransferItemAndOrderLevelApprovalData, approvalAction, setIsOrderApprovalComplete, beeImage, erroOrderConfirmation)
  }, [isTransferItemAndOrderLevelApprovalData]);

  // Handle cancel order response
  useEffect(() => {
    if (isOrderCanceled?.approval !== undefined && actionPopupValue.actionby === "CancelOrderBtn") {
      if (isOrderCanceled.approval) {
        dispatch(RequisitionAction.setIsChangesOccured(false))
        let cancelorder = "Order Cancelled Successfully"
        setApprovalAction({
          ...approvalAction,
          actionby: actionPopupValue.actionby,
          cancelorder
        });
      }
      else {
        let cancelorder = "Order Cancelled Failed"
        setApprovalAction({
          ...approvalAction,
          actionby: actionPopupValue.actionby,
          cancelorder
        });
      }
    }
  }, [isOrderCanceled?.approval, actionPopupValue.actionby])

  // Show cancel order success/failure popup
  useEffect(() => {
    if (approvalAction.actionby === "CancelOrderBtn") {
      setPopupcontent({
        ...Popupcontent,
        titleImg: RejectedBee,
        title: "Success",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: (
          <>
            <p>{approvalAction.cancelorder}</p>
          </>
        ),
        primaryBtnText: "",
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isCompletedReportVisible: false,
        outlineBtnnavigateTo: headerNav === "Customer My Orders" ? "Customer My Orders" : headerNav,
        primaryBtnnavigateTo: "",
        href: "/ordermanagement",
        actionby: ""
      });
    }
  }, [approvalAction]);

  const popupPrimarybtnOnclick = (
    item: any,
    comments: string,
    actionby: string,
    value: any,
    returnOrderconfirmation: any,
    rejectOrderconfirmation: any,
    approveOrderconfirmation: any,
    submitOrderconfirmation: any
  ) => {

    if (actionby === "CancelOrderBtn") {
      const orderId = requesttype === CONSTANTS.AFEREQUEST ? afeOrderByIdData?.orderId : transferOrderByIdData?.orderId;
      cancelOrderRequest({ orderId: orderId, savedBy: getUserDetails?.emailId, comments: comments });
      dispatchActionPopupValue({
        actionby: actionby
      });
      hideDialog();
    } else if (actionby === "CancelApprovalBtn") {
      if (item !== "") {
        dispatchNav(item);
        navigate('/ordermanagement');
      }
      hideDialog();
    } else {
      setApprovalAction({
        ...approvalAction,
        actionby,
        returnOrderconfirmation,
        rejectOrderconfirmation,
        approveOrderconfirmation,
        submitOrderconfirmation
      });

      dispatch(setIsTransferItemAndOrderLevelApproval(null))
      transferOrderApprovalRequest.approverActionId = value;
      transferOrderApprovalRequest.comment = comments;
      transferOrderApprovalRequest.isApprovalOverride = isOverrideActionapplicable
      dispatch(setTransferOrderApprovalRequest(transferOrderApprovalRequest));
      dispatchTransferItemAndOrderLevelApproval(transferOrderApprovalRequest)
      hideDialog();
    }
  };

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const returnOrderReq = (returnOrdersubtext: any, Comment: any) => {
    const result = transferApproverActionData.filter(
      (approverAction: any) => approverAction?.text === "Request More Info"
    );
    setPopupcontent({
      ...Popupcontent,
      comment: Comment,
      titleImg: CommentBee,
      title: "RETURN ORDER TO REQUESTOR",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: returnOrdersubtext,
      primaryBtnText: "Return",
      outlineBtnText: "Cancel",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "",
      actionby: "ReturnSubmitbtn",
      value: result[0]?.value,
    });
  };

  const rejectOrderReq = (rejectOrdersubtext: any, Comment: any) => {
    const result = transferApproverActionData.filter(
      (approverAction: any) => approverAction?.text === "Reject"
    );
    setPopupcontent({
      ...Popupcontent,
      comment: Comment,
      titleImg: CommentBee,
      title: "REJECT ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: rejectOrdersubtext,
      primaryBtnText: "Reject",
      outlineBtnText: "Cancel",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "",
      actionby: "RejectSubmitBtn",
      value: result[0]?.value,
    });
  };

  const approveOrderContentFun = (approveOrdersubtext:any,Comment:any) => {
    const result = transferApproverActionData.filter(
      (approverAction: any) => approverAction?.text === "Approve"
    );
    setPopupcontent({
      ...Popupcontent,
      comment: Comment,
      titleImg: WarningBee,
      title: "APPROVE ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: approveOrdersubtext,
      primaryBtnText: "Approve",
      outlineBtnText: "Cancel",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: false,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "",
      actionby: "ApproveSubmitBtn",
      value: result[0]?.value,
    });
  }

  const submitOrderFunction = (approveOrdersubtext?: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: WarningBee,
      title: "SUBMIT APPROVAL",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: approveOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "Home",
      actionby: "SubmitOrderBtn",
    });
  }

  const isValidForPenaltyFee = (selectedOption?: any) => {
    if (selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_NO_TITLE || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_NO_TITLE ||
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_TITLED || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_TITLED) {
      return true
    } else {
      return false
    }
  }

  const approveOrderReq = (approveOrdersubtext: any, Comment: any) => {
    if (requesttype == CONSTANTS.AFEREQUEST) {
      approveOrderContentFun(approveOrdersubtext, Comment)
    } else {
      transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailsByIdItem: any) => {
        if (isValidForPenaltyFee(detailsByIdItem?.dispositionType) && totalPenaltyFee > 0) {
          let decriptionTxt = (
            <div>
              <p>A Write Off Penalty Fee of ${parseFloat(`${totalPenaltyFee}`).toFixed(2)} will be assessed if you proceed with the Approval.</p>
            </div>
          );
          setWarningPopupcontent({
            ...WarningPopupcontent,
            titleImg: ConfirmationBee,
            title: "Approval Warning !",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "No",
            primaryBtnText: "Yes",
            isSingleConfirmationBtn: false,
            popupOutlinebtnOnclick: () => {
              warningHideDialog();
            },
            popupPrimarybtnOnclick: () => {
              warningHideDialog();
              approveOrderContentFun(approveOrdersubtext, Comment)
            },
          });
        }
        else {
          approveOrderContentFun(approveOrdersubtext, Comment)
        }
      })
    }
  };

  const cancelOrderReq = (cancelOrdersubtext: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "Home",
      actionby: "CancelApprovalBtn",
    });
  };

  const cancelActualOrderReq = (cancelOrdersubtext: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: RejectedBee,
      title: "CANCEL ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: headerNav === "Customer My Orders" ? "Customer My Orders" : headerNav,
      actionby: "CancelOrderBtn",
      href: "/ordermanagement",
    });
  };

  const itemLevelPenaltyFee = () => {
    let itemPenaltyFee = 0;
    let approvedItemIds: any = [];
    if (transferOrderApprovalRequest?.requestApproveVMs?.length) {
      transferOrderApprovalRequest?.requestApproveVMs?.map((approvedValue?: any) => {
        if (approvedValue?.approverActionId == "1") {
          approvedItemIds?.push(approvedValue?.requestId)
        }
      })

    }
    if (approvedItemIds?.length) {
      transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailItem?: any) => {
        detailItem?.assets?.map((assetItem?: any) => {
          if (approvedItemIds?.includes(assetItem?.transferDispoReactivationAssetDetailId)) {
            itemPenaltyFee = itemPenaltyFee + assetItem?.dispositionPenaltyFee;
          }
        })
      })
    }
    return itemPenaltyFee
  }

  const submitOrderReq = (approveOrdersubtext: any) => {
    transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailsByIdItem: any) => {
      if (isValidForPenaltyFee(detailsByIdItem?.dispositionType) && itemLevelPenaltyFee() > 0) {
        let decriptionTxt = (
          <div>
            <p>A Write Off Penalty Fee of ${parseFloat(`${itemLevelPenaltyFee()}`).toFixed(2)} will be assessed if you proceed with the Approval.</p>
          </div>
        );
        setWarningPopupcontent({
          ...WarningPopupcontent,
          titleImg: ConfirmationBee,
          title: "Approval Warning !",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          outlineBtnText: "No",
          primaryBtnText: "Yes",
          isSingleConfirmationBtn: false,
          popupOutlinebtnOnclick: () => {
            warningHideDialog();
          },
          popupPrimarybtnOnclick: () => {
            warningHideDialog();
            submitOrderFunction(approveOrdersubtext);
          },
        });
      }
      else {
        submitOrderFunction(approveOrdersubtext);
      }
    })
  };

  const disableSubmitOrder = () => {
    let assetsCount = 0;
    transferOrderByIdData?.transferDisposeReactivationDetails?.map((item: any, index: any) => {
      assetsCount = assetsCount + parseInt(item?.assets?.length)
    })
    if (assetsCount === transferOrderApprovalRequest?.requestApproveVMs?.length) {
      return false;
    } else {
      return true;
    }
  };

  const disableApproveOrder = () => {
    if (commentError === true) {
      return true;
    } else {
      return false;
    }
  };

  const handleClickBack = () => {
    dispatchNav(headerNavItem);
    navigate('/ordermanagement');
  }

  const getUserRoles = () => {
    let roles = getUserDetails?.roles?.map((role: any) => role.roleName)
    return roles
  }

  const requestDetails =  transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailsByIdItem: any) => detailsByIdItem).pop() ?? {}

  const createdRequestTypeVal = () => {
    if(requestDetails?.orderRequestType){
      return requestDetails?.orderRequestType == CONSTANTS?.TRANSFER_REQUEST ? CONSTANTS.TRANSFER : requestDetails?.orderRequestType === CONSTANTS?.DISPOSITION_REQUEST ? CONSTANTS.DISPOSITION : CONSTANTS.REACTIVATION
    } else if(requesttype === CONSTANTS.AFEREQUEST) {
      return CONSTANTS.AFEREQUEST
    }else{
      return "-"
    }
  }
 
  return (
    <AssetApproval
      transferApprovalRequestOption={transferApprovalRequestOption}
      transferOrderByIdData={ requesttype === CONSTANTS.AFEREQUEST ? afeOrderByIdData : transferOrderByIdData}
      breadcrumlist={defaultBreadcrumList(dispatchNav, headerNavItem, navigate, "Approve Request")}
      comment={comment}
      onChangeComment={onChangeComment}
      returnOrderReq={returnOrderReq}
      rejectOrderReq={rejectOrderReq}
      approveOrderReq={approveOrderReq}
      cancelOrderReq={cancelOrderReq}
      cancelActualOrderReq={cancelActualOrderReq}
      submitOrderReq={submitOrderReq}
      Popupcontent={Popupcontent}
      popupPrimarybtnOnclick={popupPrimarybtnOnclick}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      hideDialog={hideDialog}
      commentError={commentError}
      disableSubmitOrder={disableSubmitOrder}
      disableApproveOrder={disableApproveOrder}
      handleClickBack={handleClickBack}
      mobile={mobile}
      wrapperRef={wrapperRef}
      createdRequestTypeVal = {createdRequestTypeVal}
      isOverrideActionapplicable = {isOverrideActionapplicable}
      WarningPopupcontent={WarningPopupcontent}
      warningHideDialog={warningHideDialog}
      requesttype = {requesttype}
      getUserRoles={getUserRoles}
      userDetails={getUserDetails}
    />
  )
}

export default AssetApprovalContainer